var map = {
	"./example1.png": "eae2",
	"./example2.png": "0ccc",
	"./example3.png": "cbd7b",
	"./example4.png": "7d16",
	"./example5.png": "4857",
	"./example6.png": "ed17",
	"./example7.png": "2f37",
	"./example8.png": "7de5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "62ba";